import React from 'react';
import Card from '../ui/Card';

// `embedded`: rendered inside a dashboard WidgetShell, which already provides
// the title bar — skip the internal header so users don't see two banners.
function StatsCard({ sessionStats, navigate, embedded = false }) {
  return (
    <Card style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%', padding: 0 }}>
      {!embedded && (
        <div style={cardHeaderStyle}>
          <div style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Billing Stats</div>
        </div>
      )}
      <div style={cardBodyStyle}>
        <div style={statsGridStyle}>
          <div style={statsBoxStyle}>
            <div style={statTitleStyle}>No Shows</div>
            <div style={{
              ...statValueStyle,
              color: sessionStats.noShowWeekCount === 0 ? 'var(--success-color)' :
                     sessionStats.noShowWeekCount <= 2 ? '#F59E0B' :
                     'var(--error-color)'
            }}>
              {sessionStats.noShowWeekCount} | {sessionStats.noShowMonthCount}
            </div>
            <div style={statSubtextStyle}>Weekly | Monthly</div>
          </div>

          <div style={statsBoxStyle}>
            <div style={statTitleStyle}>Cancellations</div>
            <div style={{
              ...statValueStyle,
              color: sessionStats.cancelWeekCount === 0 ? 'var(--success-color)' :
                     sessionStats.cancelWeekCount <= 3 ? '#F59E0B' :
                     'var(--error-color)'
            }}>
              {sessionStats.cancelWeekCount} | {sessionStats.cancelMonthCount}
            </div>
            <div style={statSubtextStyle}>Weekly | Monthly</div>
          </div>

          <div
            style={{ ...statsBoxStyle, cursor: 'pointer' }}
            onClick={() => navigate('/therapist/debt')}
            title="View debt records"
          >
            <div style={statTitleStyle}>Debts</div>
            <div style={{
              ...statValueStyle,
              color: sessionStats.debtCount === 0 ? 'var(--success-color)' : 'var(--error-color)'
            }}>
              {sessionStats.debtCount}
            </div>
            <div style={statSubtextStyle}>${sessionStats.debtTotal.toFixed(2)}</div>
          </div>

          <div style={statsBoxStyle}>
            <div style={statTitleStyle}>Weekly Avg</div>
            <div style={{ ...statValueStyle, color: '#3B82F6' }}>
              {sessionStats.monthlyAvgCount}
            </div>
            <div style={statSubtextStyle}>Last 4 weeks</div>
          </div>
        </div>
      </div>
    </Card>
  );
}

const cardHeaderStyle = {
  background: 'var(--primary-color)',
  padding: '14px 20px',
};

const cardBodyStyle = {
  padding: '18px 20px',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
};

const statsGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px',
  flex: 1,
};

const statsBoxStyle = {
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: 'var(--secondary-color)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

const statTitleStyle = {
  fontSize: '0.8rem',
  fontWeight: 700,
  color: 'var(--muted-color)',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  marginBottom: '6px',
};

const statValueStyle = {
  fontSize: '1.5rem',
  fontWeight: 'bold',
};

const statSubtextStyle = {
  fontSize: '0.75rem',
  color: 'var(--text-muted)',
  marginTop: '4px',
};

export default StatsCard;
